import { createInstance, dateReviver } from '@/api';
import { DataConnectionDto, DataConnectionClient } from '@/api/backoffice/clients';
import { i18n } from '@/i18n';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';

export interface sourceentityStoreState {
    items?: DataConnectionDto[];
    loading: boolean;
}

export const client = new DataConnectionClient('', createInstance(), dateReviver);

export const useDataconnectionStore = defineStore('dataconnection-store', {
    state: (): sourceentityStoreState => ({
        items: [],
        loading: false
    }),
    getters: {},
    actions: {
        async get() {
            this.loading = true;
            try {
                const response = await client.get();
                this.items = response;
            } catch (error) {
                useAlertStore().handleException(i18n.global.t('dataconnection.detail.error.get.title'), error, false);
            } finally {
                this.loading = false;
            }
        }
    }
});
